/**
 * Collection of super-minimal or no-op implementations of browser
 * features that might be missing in older browsers.
 */

// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

// MIT license

(function() {
   var lastTime = 0;
   var vendors = ['ms', 'moz', 'webkit', 'o'];
   for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
      window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
      window.cancelAnimationFrame =
         window[vendors[x] + 'CancelAnimationFrame'] ||
         window[vendors[x] + 'CancelRequestAnimationFrame'];
   }

   if (!window.requestAnimationFrame) {
      window.requestAnimationFrame = function(callback, element) {
         var currTime = new Date().getTime();
         var timeToCall = Math.max(0, 16 - (currTime - lastTime));
         var id = window.setTimeout(function() {
            callback(currTime + timeToCall);
         }, timeToCall);
         lastTime = currTime + timeToCall;
         return id;
      };
   }

   if (!window.cancelAnimationFrame) {
      window.cancelAnimationFrame = function(id) {
         clearTimeout(id);
      };
   }
})();

// classList polyfill
// source: https://developer.mozilla.org/en-US/docs/Web/API/Element/classList
//    and: https://gist.github.com/k-gun/c2ea7c49edf7b757fe9561ba37cb19ca
(function() {
   // helpers
   var regExp = function(name) {
      return new RegExp('(^| )' + name + '( |$)');
   };
   var forEach = function(list, fn, scope) {
      for (var i = 0; i < list.length; i++) {
         fn.call(scope, list[i]);
      }
   };

   // class list object with basic methods
   function ClassList(element) {
      this.element = element;
   }

   ClassList.prototype = {
      add: function() {
         forEach(
            arguments,
            function(name) {
               if (!this.contains(name)) {
                  this.element.className += this.element.className.length > 0 ? ' ' + name : name;
               }
            },
            this
         );
      },
      remove: function() {
         forEach(
            arguments,
            function(name) {
               this.element.className = this.element.className.replace(regExp(name), '');
            },
            this
         );
      },
      toggle: function(name) {
         return this.contains(name) ? (this.remove(name), false) : (this.add(name), true);
      },
      contains: function(name) {
         return regExp(name).test(this.element.className);
      },
      // bonus..
      replace: function(oldName, newName) {
         this.remove(oldName), this.add(newName);
      },
   };

   // IE8/9, Safari
   if (!('classList' in Element.prototype)) {
      Object.defineProperty(Element.prototype, 'classList', {
         get: function() {
            return new ClassList(this);
         },
      });
   }

   // replace() support for others
   if (window.DOMTokenList && DOMTokenList.prototype.replace == null) {
      DOMTokenList.prototype.replace = ClassList.prototype.replace;
   }
})();

/**
 * Polyfill for ES6's Object.assign(). Added by itself as a stop-gap for IE11
 *
 * Source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 *
 * TODO: remove this when / if we include a whole library of polyfills
 */
if (typeof Object.assign != 'function') {
   // Must be writable: true, enumerable: false, configurable: true
   Object.defineProperty(Object, 'assign', {
      value: function assign(target, varArgs) {
         // .length of function is 2
         'use strict';
         if (target == null) {
            // TypeError if undefined or null
            throw new TypeError('Cannot convert undefined or null to object');
         }

         var to = Object(target);

         for (var index = 1; index < arguments.length; index++) {
            var nextSource = arguments[index];

            if (nextSource != null) {
               // Skip over if undefined or null
               for (var nextKey in nextSource) {
                  // Avoid bugs when hasOwnProperty is shadowed
                  if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                     to[nextKey] = nextSource[nextKey];
                  }
               }
            }
         }
         return to;
      },
      writable: true,
      configurable: true,
   });
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/includes
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
if (!Array.prototype.includes) {
   Object.defineProperty(Array.prototype, 'includes', {
      value: function(searchElement, fromIndex) {
         // 1. Let O be ? ToObject(this value).
         if (this == null) {
            throw new TypeError('"this" is null or not defined');
         }

         var o = Object(this);

         // 2. Let len be ? ToLength(? Get(O, "length")).
         var len = o.length >>> 0;

         // 3. If len is 0, return false.
         if (len === 0) {
            return false;
         }

         // 4. Let n be ? ToInteger(fromIndex).
         //    (If fromIndex is undefined, this step produces the value 0.)
         var n = fromIndex | 0;

         // 5. If n ≥ 0, then
         //  a. Let k be n.
         // 6. Else n < 0,
         //  a. Let k be len + n.
         //  b. If k < 0, let k be 0.
         var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

         function sameValueZero(x, y) {
            return (
               x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y))
            );
         }

         // 7. Repeat, while k < len
         while (k < len) {
            // a. Let elementK be the result of ? Get(O, ! ToString(k)).
            // b. If SameValueZero(searchElement, elementK) is true, return true.
            // c. Increase k by 1.
            if (sameValueZero(o[k], searchElement)) {
               return true;
            }
            k++;
         }

         // 8. Return false
         return false;
      },
   });
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
// https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
if (!Array.prototype.findIndex) {
   Object.defineProperty(Array.prototype, 'findIndex', {
      value: function(predicate) {
         // 1. Let O be ? ToObject(this value).
         if (this == null) {
            throw new TypeError('"this" is null or not defined');
         }

         var o = Object(this);

         // 2. Let len be ? ToLength(? Get(O, "length")).
         var len = o.length >>> 0;

         // 3. If IsCallable(predicate) is false, throw a TypeError exception.
         if (typeof predicate !== 'function') {
            throw new TypeError('predicate must be a function');
         }

         // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
         var thisArg = arguments[1];

         // 5. Let k be 0.
         var k = 0;

         // 6. Repeat, while k < len
         while (k < len) {
            // a. Let Pk be ! ToString(k).
            // b. Let kValue be ? Get(O, Pk).
            // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
            // d. If testResult is true, return k.
            var kValue = o[k];
            if (predicate.call(thisArg, kValue, k, o)) {
               return k;
            }
            // e. Increase k by 1.
            k++;
         }

         // 7. Return -1.
         return -1;
      },
   });
}
